import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { getTours, getTourGroups } from "../Api/TourApi";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Col,
  Row,
} from "reactstrap";
import { Image, Transformation } from "cloudinary-react";

const navLinkStyle = { color: "#000", padding: "8px 16px" };
const dropdownHeaderStyle = { fontWeight: 700, fontSize: "105%", padding: "0.25rem" };
const dropdownItemStyle = { padding: "0.35rem 0.5rem" };

const TopNav = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [origTours, setOrigTours] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function fetchTours() {
      const response = await getTours();
      if (!cancelled) {
        setOrigTours(
          response.data.sort(
            (a, b) => a["attributes"].sortOrder - b["attributes"].sortOrder
          )
        );
      }
    }
    fetchTours();
    return () => { cancelled = true; };
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  let megaMenuStyle;
  if (windowWidth > 1500) {
    megaMenuStyle = { width: "1450px", left: "-450px" };
  } else if (windowWidth > 1400) {
    megaMenuStyle = { width: "1350px", left: "-380px" };
  } else if (windowWidth > 1300) {
    megaMenuStyle = { width: "1200px", left: "-280px" };
  } else if (windowWidth > 991) {
    megaMenuStyle = {
      width: Math.ceil(windowWidth - windowWidth / 10) + "px",
      left: Math.ceil((windowWidth / 5) * -1) + "px",
      marginRight: "10px",
    };
  }

  const tourCategories = [
    { key: "underground", label: "Underground Tours" },
    { key: "historic",    label: "Historic Tours" },
    { key: "foodanddrink", label: "Food & Drink Tours" },
    { key: "haunted",     label: "Haunted Tours" },
  ];

  return (
    <Navbar color="light" light fixed="top" expand="lg" style={{ zIndex: 1000 }}>
      <Container>
        <NavbarBrand href="/">
          <Image
            cloudName="american-legacy-tours"
            publicId="/img/logo-color-big"
            fetchpriority="high"
            fetch_format="auto"
            width={187}
            height={66}
            style={{ width: 187, height: 66 }}
          >
            <Transformation height="66" width="187" />
          </Image>
        </NavbarBrand>

        <NavbarToggler onClick={toggle} />

        <Collapse isOpen={isOpen} navbar>
          <Nav className="m-auto" navbar>

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret style={navLinkStyle}>
                Tours
              </DropdownToggle>
              <DropdownMenu style={megaMenuStyle}>
                <Row style={{ marginLeft: "10px" }}>
                  {tourCategories.map(({ key, label }, i) => (
                    <Col key={key} sm="12" md="3">
                      {i > 0 && <hr className="d-block d-md-none" />}
                      <DropdownItem header style={dropdownHeaderStyle}>
                        {label}
                      </DropdownItem>
                      {origTours.map((tour) =>
                        tour["attributes"].groups.includes(key) &&
                        tour["attributes"].enabled ? (
                          <DropdownItem
                            key={tour["attributes"].pathTitle}
                            href={tour["attributes"].pathTitle}
                            style={dropdownItemStyle}
                            className="text-wrap"
                          >
                            {tour["attributes"].title}
                          </DropdownItem>
                        ) : null
                      )}
                    </Col>
                  ))}
                </Row>
              </DropdownMenu>
            </UncontrolledDropdown>

            <NavItem>
              <NavLink href="/gift-certificates" style={navLinkStyle}>
                Gift&nbsp;Cards
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="/event-calendar" style={navLinkStyle}>
                Calendar
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="/private-tours" style={navLinkStyle}>
                Private&nbsp;Tours
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="/faq" style={navLinkStyle}>
                FAQ
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="/contact-us" style={navLinkStyle}>
                Contact&nbsp;Us
              </NavLink>
            </NavItem>

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret style={navLinkStyle}>
                About&nbsp;Us
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem href="/about-us">Our Story</DropdownItem>
                <DropdownItem href="/featured">Featured In</DropdownItem>
                <DropdownItem href="/friends">Our Friends</DropdownItem>
                <DropdownItem href="/hiring">Now Hiring</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default TopNav;
